export default {
  title: 'Bestell Layout',
  form: {
    show_hero_image_with_offers: {
      label: 'Hero-Bild mit Angeboten anzeigen',
      description:
        'Standardmäßig wird das Hero-Bild ausgeblendet, sobald ein Angebotsbild hinzugefügt wird. Aktiviere dies, um beide anzuzeigen.',
    },
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
  },
};
